import { create } from 'zustand';

/**
 * Staff tenant impersonation store.
 * When an AD staff user is in "Client View", they can select a tenant
 * to view client pages as that tenant. This store holds the selection.
 */

interface ImpersonationState {
  selectedTenantId: string | null;
  selectedTenantName: string | null;
  setTenant: (tenantId: string | null, tenantName?: string | null) => void;
  clear: () => void;
}

export const useImpersonationStore = create<ImpersonationState>((set) => ({
  selectedTenantId: null,
  selectedTenantName: null,
  setTenant: (tenantId, tenantName = null) =>
    set({ selectedTenantId: tenantId, selectedTenantName: tenantName }),
  clear: () => set({ selectedTenantId: null, selectedTenantName: null }),
}));
